@let ci = content();
@if (ci) {
  <button (click)="trackInfoEvent()" class="text-hover-dark  hover:bg-default-200 w-full">
    <div class="flex w-full gap-2 md:gap-3">
      <div class="basis-10 w-10">
        <img [src]="npImageUrl()" [alt]="npImageLabel()" [title]="npImageLabel()" [aria-label]="npImageLabel()" class="size-10"/>
      </div>

      <div class="grow-1">
        <kexp-mini-track-info [content]="ci" showAlbum="false"></kexp-mini-track-info>
      </div>

      <div class="ml-auto self-center basis-10 text-center">
          <div class="text-xl text-default-500">
            <fa-icon [icon]="faChevronRight"></fa-icon>
          </div>
      </div>
    </div>
  </button>
}
